import { FC } from "react";
import { Box, Text } from "@smile2impress/components";

import { Typeform } from "components/Typeform";

import { CandidateLayoutProps } from "./CandidateLayout.types";

export const CandidateLayout: FC<CandidateLayoutProps> = ({
    title,
    typeformIds,
}) => {
    return (
        <Box h="100svh">
            <Text
                as="h1"
                sx={{
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    padding: 0,
                    margin: "-1px",
                    overflow: "hidden",
                    clip: "rect(0, 0, 0, 0)",
                    whiteSpace: "nowrap",
                    border: 0,
                }}
            >
                {title}
            </Text>
            <Typeform typeformIds={typeformIds} />
        </Box>
    );
};
